import { render, staticRenderFns } from "./CoTwoTransportForm.vue?vue&type=template&id=77d09128&scoped=true&"
import script from "./CoTwoTransportForm.vue?vue&type=script&lang=js&"
export * from "./CoTwoTransportForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d09128",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77d09128')) {
      api.createRecord('77d09128', component.options)
    } else {
      api.reload('77d09128', component.options)
    }
    module.hot.accept("./CoTwoTransportForm.vue?vue&type=template&id=77d09128&scoped=true&", function () {
      api.rerender('77d09128', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/carbonclap/components/green/form/CoTwoTransportForm.vue"
export default component.exports